import utils from './utils'
import AuthService from './services/auth-service';

class TxMessageType {
  constructor() {
    this.Cmd = 0;
    this.Payload = [];
  }
  SetPayload(payload) { this.Payload = [...payload]; }
  ToBytes() {
    let b = [];
    b.push(0xf0); // SOT
    b.push(0x00); // len
    b.push(this.Cmd); // cmd name
    b.push(...this.Payload);
    b.push(0x00); // checksum

    b[1] = b.length - 3; // ora conosco la len del messaggio

    let sum = 0;
    for (let i = 1; i < b.length - 1; i++) {
      sum += b[i];
    }
    b[b.length - 1] = sum & 0xff; // checksum

    // devo fare l'escape dei caratteri "speciali"
    let b0 = [b[0]];
    for (let i = 1; i < b.length; i++) {
      switch (b[i]) {
        case 0xf0:
          b0.push(0xef);
          b0.push(0x01);
          break;
        case 0xef:
          b0.push(0xef);
          b0.push(0x00);
          break;
        default:
          b0.push(b[i]);
          break;
      }
    }
    return b0;
  }
}
class RxMessageType {
  constructor() {
    this.Cmd = 0;
    this.Payload = [];
  }
  SetPayload(payload) {
    this.Payload = payload.map(item => item) // faccio la copia
  }
  IsAck() {
    return this.Payload[0] === 0x64;
  }
}

class CanMessage {
  constructor(b = undefined) {
    if (b === undefined) {
      this.Id = 0
      this.Data = []
      this.DataLength = 0
      this.TxPriority = 0
      this.TimeStamp = 0     
      this.local_timestamp = new Date() // Aggiungi timestamp 
    } else {
      this.Id = (b[0] << 24) + (b[1] << 16) + (b[2] << 8) + b[3];
      this.Data = b.slice(4, 12);
      this.DataLength = b[12];
      this.TxPriority = b[13];
      this.TimeStamp = (b[14] << 8) + b[15];     
      this.local_timestamp = new Date() // Aggiungi timestamp 
    }
    this.color = undefined; 
  }
  clone() {
    var m = new CanMessage()
    m.Id = this.Id
    m.Data = this.Data.map(o => o)
    m.DataLength = this.DataLength
    m.TxPriority = this.TxPriority
    m.TimeStamp = this.TimeStamp
    m.local_timestamp = this.local_timestamp // Aggiungi timestamp
    m.color = this.color; // copia il colore
    return m
  }
  toString() {
    let s = `${MyCanUtils.HEX(this.Id, 8)}   ${MyCanUtils.B_HEX(this.Data)}`
    return s
  }
  toStringWithTimestamp() {
    const date = new Date(this.local_timestamp);
    const formattedTime = date.toLocaleTimeString('it-IT', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3 // Aggiunge i millisecondi
    });
    return `[${formattedTime}] ${MyCanUtils.HEX(this.Id, 8)}   ${MyCanUtils.B_HEX(this.Data)}`;
  }
}
class CanMessageCollection {
  constructor() { 
    this.collection = new Map()
    this.only_last_can_message = false
    this.canIdColors = new Map(); // Mappa per memorizzare i colori degli ID
  }
  add(m) {
    if (!this.canIdColors.has(m.Id)) {
      this.canIdColors.set(m.Id, '#' + Math.floor(Math.random() * 16777215).toString(16));
    }
    m.color = this.canIdColors.get(m.Id);

    if (this.collection.has(m.Id)) {
      if (this.only_last_can_message) {
        this.collection.set(m.Id, [m])
      } else {
        this.collection.get(m.Id).push(m)
      }
    } else {
      this.collection.set(m.Id, [m])
    }
  }
  clear() {
    this.collection.clear()
    this.canIdColors.clear(); // Pulisce la mappa dei colori
  }
  toString() {
    let s = Array.from(this.collection.values())
      .flatMap(value => value) // Flatten the array of arrays
      .map(value => value.toString())
      .join('\n') + '\n'
    return s
  }
  toStrings() {
    let arrayOfStrings = Array.from(this.collection.values())
      .flatMap(value => value) // Flatten the array of arrays
      .map(value => {
        if (value) return value.toStringWithTimestamp()
        return undefined
      })
      .filter(value => value !== undefined); // remove undefined values
    return arrayOfStrings;
  }
  toArray() {
    let a = Array.from(this.collection.values())
      .flatMap(value => value) // Flatten the array of arrays
      .filter(value => value !== undefined) // Remove undefined values
      .sort((a, b) => new Date(a.local_timestamp) - new Date(b.local_timestamp)); // Sort by timestamp
    return a;
  }
  pull(id, cnt) {
    if (this.collection.has(id)) {
      ////console.log("pull", MyCanUtils.HEX(id), MyCanUtils.HEX(cnt & 0xff))
      let messages = this.collection.get(id)
      for (let i = 0; i < messages.length; i++) {
        let can_message = messages[i]
        if (can_message && can_message.Data && can_message.Data.length >= 3 && can_message.Data[2] === (cnt & 0xff)) {
          let temp = can_message.clone()
          messages.splice(i, 1) // trovato quello che cercavo
          //console.log("pull can message found", temp.toString())
          return temp
        }
      }
    }
    return null;
  }
}
class MyCanUtils {  
  static async getEcuData(uid, boot, appl) {
    try {
      // var resp = await AuthService.getProgramList()
      // console.log(resp);
      var data = await AuthService.getEcuSign({
        uid: uid,
        boot: boot,
        appl: appl,
      });
      return data;
    } catch (error) {
      console.error('Fetch error:', error);
      return undefined;
    }
  }
  static HEX(n, pad = 2) { return n.toString(16).padStart(pad, '0').toUpperCase() }
  static B_HEX(b) { return b.map(b0 => this.HEX(b0)).join(" ") }
  static computeUnlockKey(KEY_CAL, b_seed) {
    const unlock_bytes = new Uint8Array(KEY_CAL.length);
    for (let i = 0; i < KEY_CAL.length; i++) {
      unlock_bytes[i] = KEY_CAL.charCodeAt(i);
    }    
    //console.log("unlock_bytes", unlock_bytes)
    //b_seed = [131,60,41,177]
    if (b_seed.length !== 4) return false;
    const b_key = new Uint8Array(6);
    const len = unlock_bytes.length;
    let j = b_seed[0] % len;
    for (let i = 0; i < 4; i++) {
      const c = unlock_bytes[j % len];
      b_key[i] = b_seed[i] ^ c;
      j++;
    }
    b_key[4] = 0;
    b_key[5] = 0;
    //console.log("b_key", b_key)
    return b_key;
  }
  static parseS19File(txt) {
    const blocks = [];
    let currentBlock = null;
  
    const lines = txt.split('\n');
    lines.forEach(line => {
      if (line.startsWith('S1') || line.startsWith('S2') || line.startsWith('S3')) {
        const count = parseInt(line.substring(2, 4), 16);
        let addressLength;
        if (line.startsWith('S1')) {
          addressLength = 4;
        } else if (line.startsWith('S2')) {
          addressLength = 6;
        } else if (line.startsWith('S3')) {
          addressLength = 8;
        }
        const address = parseInt(line.substring(4, 4 + addressLength), 16);
        const data = [];
        for (let i = 4 + addressLength; i < 4 + addressLength + (count - (addressLength / 2) - 1) * 2; i += 2) {
          data.push(parseInt(line.substring(i, i + 2), 16));
        }
  
        if (currentBlock && address === currentBlock.endAddress + 1) {
          // If the current address is contiguous with the last address of the current block, merge the data
          currentBlock.data.push(...data);
          currentBlock.endAddress += data.length;
        } else {
          // Otherwise, start a new block
          currentBlock = {
            startAddress: address,
            endAddress: address + data.length - 1,
            data: data
          };
          blocks.push(currentBlock);
        }
      }
    });
  
    return blocks;
  }
  static toBytes(n) {
    var b = [
      n & 0xff,
      (n >> 8) & 0xff,
      (n >> 16) & 0xff,
      (n >> 24) & 0xff,
    ]
    return b
  }
}

class LL_Can {
  static ColiCmdType = {
    CMD__PING: 0,
    CMD__SEND_CAN: 1,
    CMD__GET_IDENTIFICATION: 2,
    CMD__SET_CAN_BITRATE: 3,
    CMD__JUMP2BOOT: 4,
    CMD__RESET_FACTORY: 5,
    CMD__LISTEN_MODE: 6,
    CMD__GET_CAN_BITRATE: 7,
    CMD__START_STOP: 8,
    CMD__SEND_FAST_FRAME: 9,
    CMD__LOG_COMMAND: 10,
    CMD__FLASH_BULK_ERASE: 11,
    CMD__FLASH_BULK_COMPLETED: 12,
    CMD__SET_FILTER: 13,
    CMD__HANDSHAKE_PCKS: 14,
    CMD__SEND_UART: 15,
    CMD__UART_BAUDRATE: 16,
    CMD__UART_FLUSH: 17,
    CMD__SEND_UART_ECHO: 18,
    CMD__UART_LATENCY: 19,
    CMD__UART_LEVEL: 20,
    CMD__ENTER_TRANSPARENT_MODE: 21,
    CMD__GET_AN: 22,
    CMD__ASYNC_PC_CAN: 0x81,
    _CMD_NONE_: 0xff
  }
  static EvalRxBytesResult = {
    NO_ERROR: 0,
    MISSING_START: 1,
    MISSING_END: 2,
    LESS_THAN_4_BYTES: 3,
    CHECKSUM_MISMATCH: 4,
    WRONG_LEN: 5
  }
  constructor() {
    this.comPortChanged = undefined
    this.cansUpdated = undefined
    this._async_eval = false
    this._keep_reading = undefined
    this._closed_promise = undefined
    this._can_messages = new CanMessageCollection()
    this._rxb = []
    this.port = undefined
    this.port_reader = undefined
    this.port_writer = undefined
    this.print_rx_messages = false    
  }
  setComPortChanged(comPortChanged) { this.comPortChanged = comPortChanged }
  setCansUpdated(cansUpdated) { 
    this.cansUpdated?.([]) // se per caso al giro prima era settato, svuoto la lista
    this.cansUpdated = cansUpdated 
  }
  async selectComPort(comPortChanged) {
    try {
      this.port = await navigator.serial.requestPort()
    } catch {
      console.log("request port error")
    }
    if (this.port === undefined) {
      console.log("port undef")
      if (this.comPortChanged !== undefined) {
        this.comPortChanged(undefined)
      }
    } else { 
      const { usbProductId, usbVendorId } = this.port.getInfo();
      if (this.comPortChanged !== undefined) {
        this.comPortChanged({
          usbProductId: usbProductId,
          usbVendorId: usbVendorId,
        })
      }
    }
  }
  async Init(only_last_can_message = false, bitrate = 1) {
    console.clear()
    this._async_eval = false
    this._can_messages.clear()
    this._can_messages.only_last_can_message = only_last_can_message

    var res = await this._comm_BEGIN()
    if (res === false) return await this._comm_END("comm port error")    

    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__START_STOP, [0]) === false) 
      if (await this._exchange_message(LL_Can.ColiCmdType.CMD__START_STOP, [0]) === false) 
        return await this._comm_END("START_STOP: 0")

    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__PING, [0]) === false) return await this._comm_END("PING")
    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__GET_CAN_BITRATE, [0]) === false) return await this._comm_END("GET_CAN_BITRATE")
    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__GET_IDENTIFICATION, [0]) === false) return await this._comm_END("GET_IDENTIFICATION")
    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__SET_CAN_BITRATE, [bitrate]) === false) return await this._comm_END("SET_CAN_BITRATE: 1")
    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__LISTEN_MODE, [0]) === false) return await this._comm_END("LISTEN_MODE: 0")
    if (await this._exchange_message(LL_Can.ColiCmdType.CMD__START_STOP, [1]) === false) return await this._comm_END("START_STOP: 1")    

    console.log("_Init done!")

    this._rxb = []
    this._async_eval = true
    return true
  }
  async Done() { return await this._comm_END() }
  async TestLoop() {
    await this._send_message(LL_Can.ColiCmdType.CMD__SEND_FAST_FRAME, [0, 0, 0x01, 0xf5, 0x01, 0x03, 0, 0, 0, 0, 0, 0])
  }
  // setta i seguenti:
  //   this.port
  //   this.keepReading
  //   this.closedPromise
  //   this.writer
  async _comm_BEGIN() {    
    const ports = await navigator.serial.getPorts()
    if (ports.length === 1) {
      this.port = ports[0]
      console.log("port already granted")
    } 
    if (this.port === undefined) {
      try {
        this.port = await navigator.serial.requestPort()
      } catch {
        console.log("request port error")
      }
    }    
    if (this.port === undefined) {
      console.log("port undef")
      if (this.comPortChanged !== undefined) {
        this.comPortChanged(undefined)
      }
      return false
    }    
    const { usbProductId, usbVendorId } = this.port.getInfo();
    if (this.comPortChanged !== undefined) {
      this.comPortChanged({
        usbProductId: usbProductId,
        usbVendorId: usbVendorId,
      })
    }    
    try {
      await this.port.open({
        baudRate: 3000000
      })
    } catch (error) {
      console.log("port already open")
      return false
    }

    // procedura per attivare il protocollo USB<-->CAN
    await this.port.setSignals({ break: true })
    await utils.sleep(50)
    await this.port.setSignals({ break: false })

    if (this.port_reader === undefined) {
      this._keep_reading = true
      this._closed_promise = this._read_until_closed()
    }
    
    this.port_writer = this.port.writable.getWriter()

    console.log("commBEGIN completed")
    return true
  }
  async _comm_END(ret_msg = "ok") {
    //this.report_progress({ type: "_result", data: ret_msg })
    console.log("_comm_END message:", ret_msg)
    await utils.sleep(250)
    try {
      this.port_writer.releaseLock()
    } catch (error) {      
      console.log(error)
    }
    try {
      // Set the keep_reading flag to false and wait for the reader to finish
      this._keep_reading = false
      // Force reader.read() to resolve immediately and subsequently
      // call reader.releaseLock() in the read loop
      this.port_reader.cancel()
      await this._closed_promise
      this.port_reader = undefined
    } catch (error) {      
      console.log(error)
    }
    return (ret_msg === "ok")
  }
  async SendMultiCanMessage(cro, dto, multi_payload, print_tx = false) {
    var b_cro = [0, 0, cro >> 8, cro & 0xff]
    var b_dto = [0, 0, dto >> 8, dto & 0xff]
    var b_num = multi_payload.length
    var flattened_payload = []
    await multi_payload.map(item => flattened_payload.push(...item.payload))
    //console.log("flattened_payload", MyCanUtils.B_HEX(flattened_payload))
    var payload = [...b_cro, ...b_dto, b_num, ...flattened_payload]    
    await this._send_message(LL_Can.ColiCmdType.CMD__HANDSHAKE_PCKS, payload, print_tx)
  }
  async SendCanMessage(cro, data_payload, print_tx = false) {
    var payload = [0, 0, cro >> 8, cro & 0xff, ...data_payload]
    await this._send_message(LL_Can.ColiCmdType.CMD__SEND_FAST_FRAME, payload, print_tx)
  }
  async _send_message(cmd, payload /* array di byte */, print_tx = false) {
    let tx = new TxMessageType();
    tx.Cmd = cmd;
    tx.SetPayload(payload);
    let tx_b = tx.ToBytes();
    if (print_tx) console.log("TX ---", MyCanUtils.B_HEX(tx_b))
    await this.port_writer.write(new Uint8Array(tx_b));
  }  
  async _exchange_message(cmd, payload, to_ms = 100) {
    this._rxb = []
    await this._send_message(cmd, payload)
    var m = await this._wait_rx_message(to_ms, cmd)
    if (m === undefined) {
      console.log("_exchange_message timeout")
      return false
    }
    return m.IsAck()
  }
  async _eval_rx_bytes() {
    // cerco l'inizio del messaggio
    let i_start = this._rxb.indexOf(0xf0); // SOT
    if (i_start === -1)
      return { result: LL_Can.EvalRxBytesResult.MISSING_START }
  
    // cerco la fine del messaggio
    let i_end = this._rxb.indexOf(0xf1); // FTDI_SEND_CH
    if (i_end <= i_start)
      return { result: LL_Can.EvalRxBytesResult.MISSING_END }
  
    // ricostruisco il messaggio senza gli escape
    let b0 = [];
    let esc = false;
    for (let i = i_start + 1; i < i_end; i++) { // escludo il SOT e l'ultimo (FTDI_SEND_CH)
      if (esc) {
        switch (this._rxb[i]) {
          case 0:
            b0.push(0xef); // ESC
            break;
          case 1:
            b0.push(0xf0); // SOT
            break;
          case 2:
            b0.push(0xf1); // FTDI_SEND_CH
            break;
          default:
            break;
        }
        esc = false;
      } else if (this._rxb[i] === 0xef) {
        esc = true;
      } else {
        b0.push(this._rxb[i]);
      }
    }
  
    // rimuovo da b i byte fino a i_end compreso
    this._rxb.splice(0, i_end + 1);
  
    if (b0.length < 4)
      return { result: LL_Can.EvalRxBytesResult.LESS_THAN_4_BYTES }
  
    // calcolo il checksum
    let sum = 0;
    for (let i = 0; i < b0.length - 1; i++)
      sum += b0[i];
  
    if ((sum & 0xff) !== b0[b0.length - 1])
      return { result: LL_Can.EvalRxBytesResult.CHECKSUM_MISMATCH }
  
    let len = b0[0];
    if (len !== b0.length - 2)
      return { result: LL_Can.EvalRxBytesResult.WRONG_LEN }
  
    var m = new RxMessageType()
    m.Cmd = b0[1];
    m.SetPayload(b0.slice(2, 2 + len - 1));
    //console.log(m)
    return { 
      result: LL_Can.EvalRxBytesResult.NO_ERROR,
      m: m
    }
  }
  async _wait_rx_message(to_ms, cmd = LL_Can.ColiCmdType._CMD_NONE_) {
    var RX_SLEEP_TIME = 10
    while (true) {     
      var ret
      try {
        ret = await this._eval_rx_bytes()
      } catch (error) {
        console.log("error", error)        
      }
      if (ret.result !== LL_Can.EvalRxBytesResult.NO_ERROR) {
        // aspetto            
        ////console.log("_rxb", MyCanUtils.B_HEX( this._rxb ))
      } else if (ret.result === LL_Can.ColiCmdType._CMD_NONE_) {
        // esco con qualsiasi messaggio
        return ret.m;
      } else if (cmd === ret.m.Cmd) {
        // esco solo se ricevo questo specifico messaggio
        return ret.m;
      }
      await utils.sleep(RX_SLEEP_TIME)
      if (to_ms <= 0) return undefined;
      to_ms -= RX_SLEEP_TIME;
    }
  }
  async _read_until_closed() {
    this._rxb = []
    
    const intervalId = setInterval(() => {
      this.cansUpdated?.(this._can_messages)
    }, 100)

    try {
      while (this.port.readable && this._keep_reading) {
        this.port_reader = await this.port.readable.getReader()
        try {
          while (true) {
            try {
              const { value, done } = await this.port_reader.read()
              if (done) break // reader.cancel() è stato chiamato
              this._rxb.push(...value) // tutti gli item di value li metto in rxb
              //console.log("this._rxb", MyCanUtils.B_HEX(this._rxb))
              if (this._async_eval) {
                var trovato = false
                while (!trovato) {
                  var ret = await this._eval_rx_bytes()
                  if (ret.result === LL_Can.EvalRxBytesResult.NO_ERROR) {
                    if (ret.m.Cmd === LL_Can.ColiCmdType.CMD__ASYNC_PC_CAN) {
                      var m = new CanMessage(ret.m.Payload)
                      if (this.print_rx_messages) console.log("RX ---", m.toString())
                      this._can_messages.add(m)
                      ///console.log("_can_messages ADD", this._can_messages.toString())
                    } else {
                      console.log("**************************************************************************************************** m.Cmd", ret.m.Cmd)
                      await utils.sleep(1000)
                    }
                  } else {
                    //console.log("ret.result", ret.result) 
                    trovato = true
                  }
                }
              }
            } catch (error) {
              //await utils.sleep(100);
              console.log("error READER!!", error)
              break
            }
          }
        } catch (error) {
          console.log("len", this._rxb.length)
          console.log("error XXXXXXXXXXXXXXX", error)
        } finally {
          // permetti alla porta seriale di essere chiusa successivamente
          ///console.log("releaseLock")
          this.port_reader.releaseLock()
        }
        ///console.log("looppppppppppppp")
        await utils.sleep(100)
      }
      await this.port.close()
      console.log("_read_until_closed END")
    } finally {
      // assicurati di cancellare l'intervallo quando non è più necessario
      clearInterval(intervalId)
    }
  }
  PullCanMessage(id, cnt) { return this._can_messages.pull(id, cnt) }
  CanMessagesToString() { return this._can_messages.toString() }
}
class MultiMessage {
  constructor(cmd, cnt, payload) {
    this.cmd = cmd
    this.cnt = cnt
    this.payload = []
    this.payload.push(...payload)
    this.answer = []
  }
  setPayload(b) { this.payload.push(...b) }
  setAnswer(b) { this.answer.push(...b) }
  hasAnswer() { return this.answer.length > 0 }
}
class CCP {
  static CMD = {
    CONNECT: 1,
    DISCONNECT: 7,
    SET_MTA: 2,
    DNLOAD: 3,
    DNLOAD_6: 0x23,
    CLEAR_MEMORY: 0x10,
    PROGRAM: 0x18,
    PROGRAM_6: 0x22,
    UPLOAD: 4,
    EXCHANGE_ID: 0x17,
    SHORT_UP: 0xF,
    GET_SEED: 0x12,
    UNLOCK: 0x13,
  }
  constructor(ll_can, reportProgress) {
    this._DEBUG = false
    this._ll_can = ll_can
    this.ccp_cnt = 0
    this.ccp_cro = 0x01f5
    this.ccp_dto = 0x01f4    
    this.helper = new CCP.Helper(this, reportProgress);
  }
  async _try_exchange_ccp_message(ccp_cmd, payload, timeout) { return this._exchange_ccp_message(ccp_cmd, payload, timeout).catch(error => undefined) }
  _exchange_ccp_message(ccp_cmd, payload, timeout) {
    return new Promise((resolve, reject) => {
      this.ccp_cnt++
      var data_payload = [ccp_cmd, this.ccp_cnt & 0xff, ...payload]
      this._ll_can.SendCanMessage(this.ccp_cro, data_payload)
      if (this._DEBUG) console.log(`TX cmd ${MyCanUtils.HEX(ccp_cmd)}, cnt ${MyCanUtils.HEX(this.ccp_cnt)}   ${MyCanUtils.B_HEX(data_payload)}`)
      let isCancelled = false
      const timeoutId = setTimeout(() => {
        isCancelled = true
        reject(new Error('Timeout waiting for response'))
      }, timeout)
      const checkResponse = () => {
        if (isCancelled) return // Esci se la funzione è stata cancellata
        var m = this._ll_can.PullCanMessage(this.ccp_dto, this.ccp_cnt)
        if (m !== null) {
          //console.log("RX msg", m.toString())
          var m_pid = m.Data[0]
          var m_err = m.Data[1]
          var m_ctr = m.Data[2]
          if (m_pid === 0xff && m_ctr === (this.ccp_cnt & 0xff)) {
            clearTimeout(timeoutId); // Ferma il setTimeout
            isCancelled = true; // Cancella la funzione checkResponse
            if (m_err === 0) {
              if (this._DEBUG) console.log("RX", m.toString())
              resolve(m.Data.slice(3))
            } else {
              reject(new Error('Response error'))
            }
            return
          } 
        }
        setTimeout(checkResponse, 5);
      }      
      checkResponse()
    })
  }  

  MULTI_Count() { return this.multi.length; }
  MULTI_Clear() { this.multi = []; }
  MULTI_Add(ccp_cmd, payload) {
    this.ccp_cnt++
    var data_payload = [ccp_cmd, this.ccp_cnt & 0xff, ...payload]
    var m = new MultiMessage(ccp_cmd, this.ccp_cnt, data_payload)
    this.multi.push(m)
  }
  async MULTI_Ex(timeout = 250) { return this._exchange_multi_message(timeout).catch(error => false) }
  _exchange_multi_message(timeout) {
    return new Promise((resolve, reject) => {
      var multi_to_wait = this.multi.length
      var received_multi = 0
      this._ll_can.print_rx_messages = false
      this._ll_can.SendMultiCanMessage(this.ccp_cro, this.ccp_dto, this.multi, /*print_tx*/ false)
      let isCancelled = false;
      const timeoutId = setTimeout(() => {
        isCancelled = true // cancella la funzione checkResponse
        this._ll_can.print_rx_messages = false
        reject(new Error('Timeout waiting for response'));
      }, timeout);
      const checkResponse = () => {
        if (isCancelled) return; // esci se la funzione è stata cancellata
        for (let multi of this.multi) {
          if (!multi.hasAnswer()) {
            var m = this._ll_can.PullCanMessage(this.ccp_dto, multi.cnt)
            if (m !== null) {
              // ho trovato una risposta per questo
              let answer = m.Data.slice(3, 5)
              multi.setAnswer(answer)
              received_multi++
              ///console.log("received_multi", received_multi)
            }
          }
        }
        if (received_multi === multi_to_wait) {
          clearTimeout(timeoutId); // ferma il setTimeout
          //isCancelled = true; // cancella la funzione checkResponse
          this._ll_can.print_rx_messages = false
          resolve(true)            
          return
        }
        setTimeout(checkResponse, 5);
      }      
      checkResponse()
    })
  }  

  async CCP_Connect(station_id = 0) { return (await this._try_exchange_ccp_message(CCP.CMD.CONNECT, [station_id & 0xff, station_id >> 8, 0, 0, 0, 0], 100)) !== undefined }
  async CCP_Disconnect(station_id = 0) { return (await this._try_exchange_ccp_message(CCP.CMD.DISCONNECT, [0/*TODO: CONTROLLARE CHE FORSE QUI CI VUOLE 1*/, 0, station_id & 0xff, station_id >> 8, 0, 0], 100)) !== undefined }
  async CCP_GetSeed(priv_level = 1) { return await this._try_exchange_ccp_message(CCP.CMD.GET_SEED, [priv_level, 0, 0, 0, 0, 0], 100) }
  async CCP_Unlock(b_key) { return await this._try_exchange_ccp_message(CCP.CMD.UNLOCK, [...b_key], 100) }
  async CCP_ExchageId() { return await this._try_exchange_ccp_message(CCP.CMD.EXCHANGE_ID, [0, 0, 0, 0, 0, 0], 100) }
  async CCP_Upload(len) { return this._try_exchange_ccp_message(CCP.CMD.UPLOAD, [len, 0, 0, 0, 0, 0], 100) }
  async CCP_ClearMemory(size) { return await this._try_exchange_ccp_message(CCP.CMD.CLEAR_MEMORY, [0, 0, ...MyCanUtils.toBytes(size)], 3000) }
  async CCP_Program(num, b_data/*b_data è un array di max 5 elementi!*/) { return await this._try_exchange_ccp_message(CCP.CMD.PROGRAM, [num, ...b_data], 100) }
  async CCP_Program6(b_data/*b_data è un array di 6 elementi!*/) { return await this._try_exchange_ccp_message(CCP.CMD.PROGRAM_6, [...b_data], 100) }
  async CCP_SetMta(addr) { return await this._try_exchange_ccp_message(CCP.CMD.SET_MTA, [0, 0, ...MyCanUtils.toBytes(addr)], 100) }

  static Helper = class {
    constructor(parent, reportProgress) {
      this.parent = parent
      this.MAX_ERROR = 5
      this.UPLOAD_MAX_LEN = 5
      this.reportProgress = reportProgress
    }
    _rep(pos, size) { this.reportProgress?.({ type: "_program_block", data: { pos: pos, size: size }}) }
    _retErr(msg = "") {
      console.timeEnd("executionTime");
      if (msg === "") return true
      console.log(msg)
      return false
    }
    async CCP_ConnectUnlock(priv_level = 0x40) {
      var data
      if (await this.parent.CCP_Connect() === false) return false
      var device_id = await this.CCP_GetDeviceId()
      console.log("device id:", device_id)  
      data = await this.parent.CCP_GetSeed(priv_level)
      if (data === undefined) return false     
      console.log("prot status:", MyCanUtils.HEX(data[0]))
      console.log("seed:", MyCanUtils.B_HEX(data.slice(1, 5)))
      var b_key = MyCanUtils.computeUnlockKey("df6jfbnmjerDsVa1", data.slice(1, 5))
      data = await this.parent.CCP_Unlock(b_key)
      if (data === undefined) return false     
      console.log("priv status:", MyCanUtils.HEX(data[0]))    
      return true
    }
    async CCP_ProgramBlock(start_addr, block_size, block_data, MAX_DATA_LEN = 6) {
      console.time("executionTime");
      var data
      this._rep(0, block_size)
      //console.log("+++ set mta", MyCanUtils.HEX(start_addr, 4))
      if (await this.parent.CCP_SetMta(start_addr) === false) return this._retErr("ERR set mta 0")
      //console.log("+++ clear memory", MyCanUtils.HEX(block_size, 4))
      data = await this.parent.CCP_ClearMemory(block_size)
      if (data === undefined) return this._retErr("ERR clear mem")      
      var max_err = this.MAX_ERROR
      var i = 0   
      var curr_addr = start_addr + i
      //console.log("+++ set mta", MyCanUtils.HEX(curr_addr, 6))
      if (await this.parent.CCP_SetMta(curr_addr) === false) return this._retErr("ERR set mta 1")
      while (i < block_size) {
        curr_addr = start_addr + i
        var b_data = block_data.slice(i, i + MAX_DATA_LEN)
        //console.log(`+++ program ${MyCanUtils.HEX(curr_addr, 6)}   ${MyCanUtils.B_HEX(b_data)}`)
        if (MAX_DATA_LEN === 6) {
          data = await this.parent.CCP_Program6(b_data)
        } else {
          var b_temp = new Array(5 - MAX_DATA_LEN).fill(0)
          data = await this.parent.CCP_Program(MAX_DATA_LEN, [...b_data, ...b_temp])
        }
        if (data === undefined) {
          console.log("*")
          if (--max_err <= 0) return this._retErr("ERR program")
          if (await this.parent.CCP_SetMta(curr_addr) === false) return this._retErr("ERR set mta 2")            
        } else {
          i += MAX_DATA_LEN
          max_err = this.MAX_ERROR
          this._rep(i, block_size)
        }        
      }    
      return this._retErr() //OK
    }  
        
    async MULTI_ProgramBlock(start_addr, block_size, block_data, MAX_DATA_LEN = undefined) {
      console.time("executionTime");
      var data
      this._rep(0, block_size)
      console.log("+++ set mta", MyCanUtils.HEX(start_addr, 4))
      if (await this.parent.CCP_SetMta(start_addr) === false) return this._retErr("ERR set mta 0")
      console.log("+++ clear memory", MyCanUtils.HEX(block_size, 4))
      data = await this.parent.CCP_ClearMemory(block_size)
      if (data === undefined) return this._retErr("ERR clear mem")
      var i = 0
      var last_addr = start_addr + i
      this.parent.MULTI_Clear()
      while (i < block_size) {
        var remaining_bytes = block_size - i
        var current_max_len = MAX_DATA_LEN !== undefined ? MAX_DATA_LEN : (remaining_bytes < 6 ? remaining_bytes : 6)
        var b_data = block_data.slice(i, i + current_max_len)
        i += current_max_len
        if (current_max_len === 6) {
          this.parent.MULTI_Add(CCP.CMD.PROGRAM_6, b_data)
        } else {
          var b_temp = new Array(5 - current_max_len).fill(0)
          this.parent.MULTI_Add(CCP.CMD.PROGRAM, [current_max_len, ...b_data, ...b_temp])
        }
        if (this.parent.MULTI_Count() >= 20) {
          console.log(`+++ program ${MyCanUtils.HEX(last_addr, 6)}`)
          if (await this.parent.MULTI_Ex() === false) return this._retErr("ERR multi ex")
          this.parent.MULTI_Clear()
          last_addr = start_addr + i
        }
        this._rep(i, block_size)
      }
      if (this.parent.MULTI_Count() > 0) {
        console.log(`+++ program ${MyCanUtils.HEX(last_addr, 6)}`)
        if (await this.parent.MULTI_Ex() === false) return this._retErr("ERR multi ex")
        this.parent.MULTI_Clear()
      }
      return this._retErr() //OK
    }
    async CCP_GetDeviceId() {
      var data = await this.parent.CCP_ExchageId()
      if (data === undefined) return undefined
      var device_id_len = data[0]
      var res_availability_mask = data[2]
      var res_protection_mask = data[3]
      //console.log("device_id_len", device_id_len)    
      var b = []    
      while (device_id_len > 0) {
        let len = device_id_len
        if (len > this.UPLOAD_MAX_LEN) len = this.UPLOAD_MAX_LEN
        data = await this.parent.CCP_Upload(len)
        if (data === undefined) return undefined
        device_id_len -= len;            
        b = [...b, ...data.splice(0, len)]
      }
      var device_id = b.map(byte => String.fromCharCode(byte)).join("")
      //console.log("device_id", device_id)
      return device_id
    }
    async CCP_GetString(addr, b_len) {
      var data = await this.CCP_GetBytes(addr, b_len)
      if (data === undefined) return undefined
      var s = data.map(byte => (byte === 0) ? undefined : String.fromCharCode(byte)).join("")
      return s
    }
    async CCP_GetBytesHex(addr, b_len) {
      var data = await this.CCP_GetBytes(addr, b_len)
      if (data === undefined) return undefined
      var s = data.map(byte => MyCanUtils.HEX(byte)).join("")
      return s
    }
    async CCP_GetBytes(addr, b_len) {
      var data = await this.parent.CCP_SetMta(addr)
      if (data === undefined) return undefined
      var b = []
      while (b_len > 0) {
        let len = b_len
        if (len > this.UPLOAD_MAX_LEN) len = this.UPLOAD_MAX_LEN
        data = await this.parent.CCP_Upload(len)
        if (data === undefined) return undefined
        b_len -= len;
        b = [...b, ...data.splice(0, len)]
      }
      return b
    }
  }
}



class MyCan {  
  reportProgress(o) { this.progressChanged?.(o); }  
  // chrome://device-log/  
  constructor() {
    this.comPortChanged = undefined // questo viene settato dopo la creazione dell'oggetto
    this.progressChanged = undefined
    this.cansUpdated = undefined
    this.stop_com = false    
    this._ll_can = new LL_Can()
    this._ccp = new CCP(this._ll_can, this.reportProgress.bind(this))
  }
  async selectComPort() {
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.selectComPort()    
  }

  // **********************************************************************************************
  // **********************************************************************************************
  // **********************************************************************************************

  async runTest(bitrate) {
    console.clear()

    const response = await fetch('../test/MP32_PLUS-010-0002.s19');
    console.log(response)
    if (!response.ok) {      throw new Error('Network response was not ok');    }
    var s19 = await response.text();
    var blocks = MyCanUtils.parseS19File(s19) // --> questi sono i blocchi da programmare!
    console.log("blocks[1] start : ", MyCanUtils.HEX(blocks[1].startAddress))
    console.log("blocks[1] len   : ", MyCanUtils.HEX(blocks[1].data.length))

    this.reportProgress({ type: "_working", data: 1 })
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.setCansUpdated(this.cansUpdated)
    await this._ll_can.Init(false, bitrate)

    if (await this._ccp.helper.CCP_ConnectUnlock(0x40)) {
      console.log("----------------------------------> connected ")
      this._ccp._DEBUG = true // true ! per vedere i messaggi di debug

      if (await this._ccp.helper.MULTI_ProgramBlock(blocks[1].startAddress, blocks[1].data.length, blocks[1].data, /*4*/ undefined)) {
        console.log("OK")
      }
      // if (await this._ccp.CCP_SetMta(blocks[0].startAddress) === false) {
      //   console.log("ERR set mta")
      // } else {
      //   var data = await this._ccp.CCP_ClearMemory(2048)
      //   if (data === undefined) {          
      //     console.log("ERR clear mem")
      //   } else {
      //     // scrive in flash quando ha ricevuto un blocco di 32 byte !!!
      //     this._ccp.MULTI_Clear()
      //     for (var i = 0; i < 10; i++) {
      //       this._ccp.MULTI_Add(CCP.CMD.PROGRAM_6, [0,0,0,0,0,0])
      //     }
      //     data = await this._ccp.MULTI_Ex()          

      /* for (var i = 0; i < 32; i++) {  
        data = await this._ccp.CCP_Program(1, [0])
        if (data === undefined) {
          console.log("ERR program")
        } else {
          console.log(".")
        }
      } */
          
      this._ccp._DEBUG = false
      await this._ccp.CCP_Disconnect()
      console.log("----------------------------------> disconnected ")
    }

    this.reportProgress({ type: "_working", data: 0 })
    this.reportProgress({ type: "_result", data: 0 })
    return await this._ll_can.Done()
  }
  
  // **********************************************************************************************
  // **********************************************************************************************
  // **********************************************************************************************

  async updateSign(bitrate) {
    this.reportProgress({ type: "_working", data: 1 })
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.setCansUpdated(undefined)
    await this._ll_can.Init(false, bitrate)

    if (await this._ccp.helper.CCP_ConnectUnlock() === false) {
      this.errStopErr()
    } else {

      var s_boot = await this._ccp.helper.CCP_GetString(0x5700, 20) // versione di boot in flash
      console.log("boot:", s_boot) 
      var s_appl = await this._ccp.helper.CCP_GetString(0x6800, 32) // versione di appl in flash          
      console.log("appl:", s_appl)
      var s_uid = await this._ccp.helper.CCP_GetBytesHex(0x1FFFC028 + 4, 16)
      console.log("uid:", s_uid)

      await this._ccp.CCP_Disconnect()

      const ecuData = await MyCanUtils.getEcuData(s_uid, s_boot, s_appl)
      console.log('ECU Data:', ecuData)
      var blocks = MyCanUtils.parseS19File(ecuData.value.s19)
      console.log(blocks[0].data)

      if (await this._ccp.helper.CCP_ConnectUnlock() === false) {
        this.errStopErr()
      } else if (await this._ccp.helper.MULTI_ProgramBlock(0x5800, 0x800, blocks[0].data, undefined) === false) {
        this.errStopErr()
      } else {
        console.log("PROGRAM COMPLETED!")
      }

      await this._ccp.CCP_Disconnect()
    }

    this.reportProgress({ type: "_working", data: 0 })
    this.reportProgress({ type: "_result", data: 0 })
    return await this._ll_can.Done()
  }  
  async readInfo(bitrate) {
    this.reportProgress({ type: "_working", data: 1 })
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.setCansUpdated(undefined)
    if (!await this._ll_can.Init(false, bitrate)) {
            
    } else {
      
      var priv_level = 0x40
      if (await this._ccp.helper.CCP_ConnectUnlock(priv_level) === false) {
        this.errStopErr()
      } else {
        var s_boot = await this._ccp.helper.CCP_GetString(0x5700, 20) // versione di boot in flash
        console.log("boot:", s_boot) 
        var s_appl = await this._ccp.helper.CCP_GetString(0x6800, 32) // versione di appl in flash          
        console.log("appl:", s_appl)
        var s_uid = await this._ccp.helper.CCP_GetBytesHex(0x1FFFC028 + 4, 16)
        console.log("uid:", s_uid)
        await this._ccp.CCP_Disconnect()
      }
      await this._ll_can.Done()
    }
    this.reportProgress({ type: "_working", data: 0 })
    this.reportProgress({ type: "_result", data: 0 })
  }
  async readCans(onlyLastCanMessage, bitrate) {
    this.reportProgress({ type: "_working", data: 1 })
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.setCansUpdated(this.cansUpdated)
    await this._ll_can.Init(onlyLastCanMessage, bitrate)

    this.stop_com = false
    while (!this.stop_com) {
      ///await this._ll_can.TestLoop()
      await utils.sleep(100)
    }
    console.log("stop com")
    this.reportProgress({ type: "_working", data: 0 })
    this.reportProgress({ type: "_result", data: 0 })
    return await this._ll_can.Done()
  }
  async program010(bitrate) {    
    const response = await fetch('../test/MP32_PLUS-010-0002.s19');
    console.log(response)
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    var s19 = await response.text();
    //console.log(s19)
    var blocks = MyCanUtils.parseS19File(s19)
    //console.log(blocks)

    this.reportProgress({ type: "_working", data: 1 })
    this._ll_can.setComPortChanged(this.comPortChanged)
    this._ll_can.setCansUpdated(undefined)
    await this._ll_can.Init(false, bitrate)
    
    if (await this._ccp.helper.CCP_ConnectUnlock() === false) {
      console.log("ERR CONNECT !!!")
    } else if (await this._ccp.helper.MULTI_ProgramBlock(0x6000, blocks[0].data.length /* multiplo di 6 */, blocks[0].data, /*6*/ undefined) === false) {
      console.log("ERR program block 0x6000 !!!")
    } else if (await this._ccp.helper.MULTI_ProgramBlock(0x3F800, 2048, blocks[1].data, /*4*/ undefined) === false) {
      console.log("ERR program block 0x3F800 !!!")
    } else {
      console.log("PROGRAM COMPLETED!")
    }
    await this._ccp.CCP_Disconnect()
    this.reportProgress({ type: "_working", data: 0 })
    this.reportProgress({ type: "_result", data: 0 })
    return await this._ll_can.Done()
  }

  // **********************************************************************************************
  // **********************************************************************************************
  // **********************************************************************************************

  stopComDone() {
    console.log("DONE")
    this.stop_com = true
    console.log("stop_com", this.stop_com)
  }
  errStopErr() {
    console.log("errStopErr !!!!!!!!!!!!!!!!!!!!!!!")
    this.stop_com = true
    console.log("stop_com", this.stop_com)
  }
}

export default MyCan;
export { MyCanUtils };